import Vue from 'vue'

const CloudEditConfirmInstance = Vue.extend(require('./cloudEditConfirm.vue').default);
let instance = null
let successPromise = null
let successResolve = null

let getInstance = () => {
  return new CloudEditConfirmInstance({
    el: document.createElement('div')
  })
}

let close = () => {
  instance.close()
  instance.$el.parentNode.removeChild(instance.$el);
  instance = null
  if (successResolve) {
    successResolve(false)
    successResolve = null
  }
  successPromise = null
}

let CloudEditConfirm = (info) => {
  if (instance) {
    close()
  }
  instance = getInstance()

  document.body.appendChild(instance.$el);
  successPromise = new Promise((resolve, reject) => {
    successResolve = resolve
  })
  instance.open(info, successResolve)

  return successPromise
}

export default CloudEditConfirm
